import React, { useCallback, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import shortid from 'shortid';
import Overlay from '../../Overlay/Overlay';
import Button from '../../Input/Button/Button';

import './PostErrorPopup.scss';

const PostErrorPopup = ({ errors, heading, onClose }) => {
    const cardRef = useRef(null);
    const isOpen = Boolean(errors && errors.length);

    const handleOverlayClick = useCallback(
        (event) => {
            if (cardRef.current && cardRef.current.contains(event.target)) {
                return;
            }
            onClose();
        },
        [onClose]
    );

    useEffect(() => {
        if (!isOpen) return undefined;

        const handleKeyDown = (event) => {
            if (event.key === 'Escape') onClose();
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    return (
        <div className="component-UnifiedPostBox-PostErrorPopup">
            <Overlay handleClose={handleOverlayClick}>
                <div className="post-error-popup__scroll">
                    <div
                        className="post-error-popup__content"
                        ref={cardRef}
                        role="alertdialog"
                        aria-modal="true"
                        aria-label={heading}
                    >
                        <h2 className="post-error-popup__heading">{heading}</h2>
                        <ul className="post-error-popup__messages">
                            {errors.map((error) => (
                                <li key={shortid()}>{error}</li>
                            ))}
                        </ul>
                        <Button
                            type="purple-medium-white"
                            class="post-error-popup__button"
                            value="Got it"
                            onClick={onClose}
                        />
                    </div>
                </div>
            </Overlay>
        </div>
    );
};

PostErrorPopup.propTypes = {
    /**
     * one message per reason the post was rejected
     */
    errors: PropTypes.arrayOf(PropTypes.string),
    /**
     * title of the modal
     */
    heading: PropTypes.string,
    /**
     * dismisses the modal and clears the error
     */
    onClose: PropTypes.func.isRequired,
};

PostErrorPopup.defaultProps = {
    errors: [],
    heading: "We couldn't post that",
};

export default PostErrorPopup;
